// extracted by mini-css-extract-plugin
export default {"root":"ErrorBoundary_root__tQmX1","actions":"ErrorBoundary_actions__vIOQn"};